import { useEffect } from 'react'
import { UnifiedInbox } from './inbox/UnifiedInbox'

export function ConversationsPage() {
  useEffect(() => {
    document.body.classList.add('conversations-page')
    return () => document.body.classList.remove('conversations-page')
  }, [])

  return <UnifiedInbox />
}

export default ConversationsPage
